/** @jsxImportSource @emotion/react */
import { useRegistrationDetailsModal } from '../../context'
import PlayerForm from 'src/pages/RegistrationDetails/RegistrationDetailsInfo/PlayerForm'
import TeamOfficialForm from 'src/pages/RegistrationDetails/RegistrationDetailsInfo/TeamOfficialForm'
import { Spin } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import css from '@emotion/css/macro'
import Text from 'src/components/ts-components/Text'

const RegistrationDetailsForm = () => {
  const {
    formData,
    updateFormData,
    countries,
    provinces,
    registrationDetails,
    loading,
    error,
  } = useRegistrationDetailsModal()

  if (loading && !error) {
    return (
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          height: 50vh;
        `}
      >
        <Spin size='large' style={{ color: colors.PRIMARY }} />
      </div>
    )
  }

  if (error && !loading) {
    return (
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 50vh;
          gap: 24px;
        `}
      >
        <CloseCircleOutlined
          style={{ fontSize: 48, color: colors.FIERY_RED }}
        />
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
          `}
        >
          <Text variant='heading3' weight='semiBold' color={colors.NEUTRAL_0}>
            An error occurred while loading registration details
          </Text>
          <Text
            variant='paragraphMedium'
            weight='regular'
            color={colors.NEUTRAL_50}
          >
            {error?.message ||
              'Unable to load registration details. Please try again later.'}
          </Text>
        </div>
      </div>
    )
  }

  if (registrationDetails?.registration_type_id === 1) {
    return (
      <TeamOfficialForm
        formData={formData}
        updateFormData={updateFormData}
        countries={countries}
        teamInfo={registrationDetails?.team}
      />
    )
  }

  return (
    <PlayerForm
      formData={formData}
      updateFormData={updateFormData}
      countries={countries}
      provinces={provinces}
    />
  )
}

export default RegistrationDetailsForm
